module.exports = __webpack_public_path__ + "img/logo_200.ff5da1b2.png";